declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}

export function useTracking() {
  const trackPurchase = (orderNo: string, value?: number, currency = 'USD') => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        orderNo: orderNo,
        value: value ?? 0,
        currency,
      },
    })
  }

  return { trackPurchase }
}